import { AllergenIdName } from "ts-packages/api-types/src";

import { Stack, Typography, useTheme } from "@mui/material";

import { AllergenChipOutlined } from "igfd-ui/src";

interface IngredientListItemProps {
  title: string;
  allergens?: AllergenIdName[];
  showDivider?: boolean;
  isOptional?: boolean;
}

export const IngredientListItem = ({
  title,
  allergens,
  showDivider,
  isOptional,
}: IngredientListItemProps) => {
  const {
    palette: { oscar },
  } = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      paddingY={1.5}
      sx={{
        borderBottom: showDivider
          ? `1px solid ${oscar.light.borders.gray}`
          : "none",
        minHeight: 54, // consistent row height
      }}
    >
      <Stack direction="column">
        <Typography variant="labelRMedium">{title}</Typography>
        {isOptional && (
          <Typography
            variant="labelSMedium"
            sx={{ color: oscar.light.content.content2 }}
          >
            Optional ingredient
          </Typography>
        )}
      </Stack>
      <Stack
        direction="row"
        gap={1}
        minWidth="90px"
        justifyContent="flex-end"
        alignItems="center"
      >
        {allergens?.map((allergen) => (
          <AllergenChipOutlined
            key={allergen.igfdTaxAllergenId}
            allergenName={allergen.name}
          />
        ))}
      </Stack>
    </Stack>
  );
};
